import { keys as parentKeys } from '@copro/api';

const providers = [...parentKeys.all, 'providers'] as const;

export const keys = {
  providers,

  getProvidersList: (spaceId: string) => [...providers, 'list', spaceId] as const,
  getProviders: (spaceId: string, params?: { search?: string; page?: number; limit?: number }) => [...keys.getProvidersList(spaceId), params] as const,
  getProvidersPaged: (spaceId: string, params: { search: string; page: number; pageSize: number; tagIds?: string[]; underContractOnly?: boolean }) => [...keys.getProvidersList(spaceId), 'paged', params] as const,
  getProvidersCount: (spaceId: string) => [...keys.getProvidersList(spaceId), 'count'] as const,
  getProviderById: (id: string) => [...providers, 'detail', id] as const,
  getProviderContacts: (id: string) => [...keys.getProviderById(id), 'contacts'] as const,
  getProviderContracts: (id: string) => [...keys.getProviderById(id), 'contracts'] as const,
  getProviderContractsCount: (id: string) => [...keys.getProviderContracts(id), 'count'] as const,
  getProviderDocumentsCount: (id: string) => [...keys.getProviderById(id), 'documents', 'count'] as const,

  tags: (spaceId: string) => [...providers, 'tags', spaceId] as const,
  getProviderTags: (spaceId: string) => [...keys.tags(spaceId), 'list'] as const,
}
